import { readOnly } from '../common/DataView';
import { Col, Flex, Image, Layout, Row, Tag, Tooltip } from 'antd';
import { AgentDef, TaskDef } from '../../apis/mgmt/api';
import { ClickableProps, DataViewProps } from '../common/DataView';
import { Content, Footer } from 'antd/es/layout/layout';
import { FieldTimeOutlined } from '@ant-design/icons';
import { RecentHealthIndicator, getSemaphoreColor } from '../health/RecentHealthIndicator';
import { useAgentDefListener } from '../../apis/agent/AgentDefListener';


export const AgentDefCard = function ( props:
    DataViewProps<AgentDef> & ClickableProps<AgentDef>
) {

    const { data } = useAgentDefListener({...props, ...readOnly });

    const onClick = () => { data && props.onClick && props.onClick(data); }

    // css card classes success, waiting, warn, error, process
    const state = 'process';
    const infoByState = {
        success: { color: '#50B692', text: 'online' },
        waiting: { color: '#6FC8F2', text: 'reconecting' },
        warn: { color: '#F3C15C', text: 'warning' },
        error: { color: '#b65057ff', text: 'error' },
        process: { color: '#6FC8F2', text: 'online' },
    };

    const last = data?.recentHealth?.last;
    
    function getSemaphoreClass(taskDef: TaskDef) {
        const semaphore = taskDef.recentHealth?.last?.semaphore || undefined;
        if (!semaphore) return 'mig-task-undefined';
        return 'mig-task-'+semaphore.toLowerCase();
    }


    return (data && (
        <Col key={data.id} xs={24} sm={24} md={12} lg={8} xl={8}>
        <Layout>
            <div className={"mig-card pointer"} style={{ borderColor: getSemaphoreColor(last?.semaphore) }}  onClick={onClick}>
                <Content>
                    <div style={{ marginBottom: "1em" }}>
                        <Flex justify='space-between' align='start' >
                            <span className={'mig-card-content pointer mig-in-one-line'}>
                                    <span className='mig-title-2'>{data.name}</span>
                                    <br />
                                    <small className='small' >
                                        {data.domains?.map((domain) => domain.slug).join(", ")}
                                    </small>
                            </span>
                            <RecentHealthIndicator data={data.recentHealth} {...readOnly} />
                        </Flex>
                    </div>
                    <div style={{ overflow: "hidden", height: "5.5em", paddingBottom: "0.5em" }}>
                        <Row gutter={16}>
                            { data.taskDefs?.map((taskDef) => (
                                <Col key={taskDef.id} style={{ marginBottom: "0.5em" }} xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <span title={taskDef.lastExec?.logSummary?.fatal} 
                                    className={getSemaphoreClass(taskDef)}
                                    style={{ whiteSpace: 'nowrap', overflow: 'hidden'}}
                                    >{taskDef.name}</span>
                                </Col>
                            )) }
                        </Row>
                    </div>

                </Content>
                <Footer>
                    <Row>
                        <Col span={6}>
                            <small> <FieldTimeOutlined /> {data.taskDefs?.reduce((acc, taskDef) => 
                                acc + (taskDef?.lastExec?.processTime || 0), 0
                            )} min </small>
                        </Col>
                        <Col span={18}>
                            <div style={{ textAlign: "end" }}>
                            { data.adapterDefs?.map((adapterDef) => (
                                <Image 
                                    style={{ paddingLeft: "0.5em", width: "2em"}}  preview={false} 
                                    src={`/media/${adapterDef.platformDomain?.platform?.slug}.svg`} 
                                    title={adapterDef.name}
                                />
                            )) }
                            </div>
                        </Col>
                    </Row>
                </Footer>
            </div>
        </Layout>
        </Col>

    )) || null;
}
